import "../App.css";
import { Container, Row, Col } from "react-bootstrap";

function Contact() {
  return (
    <Container>
      <Row>
        <Col className="contact d-flex flex-column justify-content-center">
          <div className="header">Contact Us</div>
          <div className="body">
            <p>Customer Service for CTGWeb2.0 is provided via email only. Our Customer Service hours are Monday through Friday, 8:30 am - 5:00 pm EST. If you are contacting us outside of that time frame, we will respond as quickly as possible during the next business day. Your e-mail will be responded to in the order it was received.</p>
            <p><a href="mailto:ctgweb@musc.edu">Click here to send us an email.</a></p>
            <p><em>If the link above does not open a new email window, you probably do not have a default email client configured on your device. You may address your email to <b>ctgweb@musc.edu</b></em>.</p>
            <p>CTGWeb2.0 operates independently of the TF-CBT Provider certification program. For questions about certification, go to the official site at <a href="https://www.tfcbt.org" target="_blank" rel="noreferrer">www.tfcbt.org</a> for details on the requirements and process, frequently asked questions, registration to pursue certification, and contact information for any additional questions.</p>
            <p>We look forward to assisting you!</p>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default Contact;
